<template>
  <div class="home-page">
    <layout>
      <template v-slot:search>
        <div class="search-wrapper" v-if="accessTo('StatController@rechargeStat') || accessTo('StatController@teamStat') || accessTo('StatController@recharges') || accessTo('StatController@recharges')">
          <div class="title">
            <a-icon type="search"/>
            数据筛选
          </div>
          <a-divider></a-divider>
          <a-space>
            <a-select show-search allow-clear placeholder="所属主体" v-model="queryParam.corporation_id"  option-filter-prop="children">
              <a-select-option :value="corporation.id" v-for="corporation in corporations" :key="corporation.id" >
                {{ corporation.name }}
              </a-select-option>
            </a-select>
            <a-select
              placeholder="小组"
              v-model="queryParam.team_id"
              @change="changeTeam"
              show-search
              allow-clear
              option-filter-prop="children"
            >
              <a-select-option :value="team.id" v-for="team in teams" :key="team.id">
                {{ team.name }}
              </a-select-option>
            </a-select>
            <a-select
              placeholder="优化师"
              v-model="queryParam.worker_id"
              @change="changeWorker"
              show-search
              allow-clear
              option-filter-prop="children"
            >
              <a-select-option :value="worker.id" v-for="worker in workers" :key="worker.id">
                {{ worker.name }}
              </a-select-option>
            </a-select>
            <a-range-picker v-model="queryParam.date" valueFormat="YYYY-MM-DD" v-show="false" />
            <a-button type="primary" @click="search">查询</a-button>
            <a-button @click="resetSearch">重置</a-button>
          </a-space>
        </div>
      </template>
      <template v-slot:content>
        <a-spin :spinning="loading || loading2 || loading3" />
        <div v-if="showWelcome && accessTo('welcome')" class="welcome">欢迎使用快手批量任务系统</div>
        <div v-if="accessTo('StatController@rechargeStat')" class="stat-box">
          <a-row :gutter="[16,16]">
            <a-col :sm="4" :xs="12">
              <a-card>
                <a-statistic title="今日ROI" :value="today.roi|percent" :precision="2"/>
                <a-divider/>
                <div>
                  <span class="yesterday-title">昨日</span>
                  <span class="yesterday-content">{{ yesterday.roi|percent }}</span>
                </div>
              </a-card>
            </a-col>
            <a-col :sm="4" :xs="12">
              <a-card>
                <a-statistic title="今日总消耗" :value="today.cost" :precision="0"/>
                <a-divider/>
                <div>
                  <span class="yesterday-title">昨日</span>
                  <span class="yesterday-content">{{yesterday.cost}}</span>
                </div>
              </a-card>
            </a-col>
            <a-col :sm="4" :xs="12">
              <a-card>
                <a-statistic title="今日总收入" :value="today.income" :precision="2"/>
                <a-divider/>
                <div>
                  <span class="yesterday-title">昨日</span>
                  <span class="yesterday-content">{{yesterday.income}}</span>
                </div>
              </a-card>
            </a-col>
            <a-col :sm="4" :xs="12">
              <a-card>
                <a-statistic title="今日充值笔数" :value="today.total_order_count" :precision="0"/>
                <a-divider/>
                <div>
                  <span class="yesterday-title">昨日</span>
                  <span class="yesterday-content">{{yesterday.total_order_count}}</span>
                </div>
              </a-card>
            </a-col>
            <a-col :sm="4" :xs="12">
              <a-card>
                <a-statistic title="今日新增用户数" :value="today.new_user_count" :precision="0"/>
                <a-divider/>
                <div>
                  <span class="yesterday-title">昨日</span>
                  <span class="yesterday-content">{{yesterday.new_user_count}}</span>
                </div>
              </a-card>
            </a-col>
            <a-col :sm="4" :xs="12">
              <a-card>
                <a-statistic title="今日新用户充值人数" :value="today.new_paid_user_count" :precision="0"/>
                <a-divider/>
                <div>
                  <span class="yesterday-title">昨日</span>
                  <span class="yesterday-content">{{yesterday.new_paid_user_count}}</span>
                </div>
              </a-card>
            </a-col>

            <a-col :sm="4" :xs="12">
              <a-card>
                <a-statistic title="新增剧目数" :value="today.new_video_count" :precision="0"/>
                <a-divider/>
                <div>
                  <span class="yesterday-title">昨日</span>
                  <span class="yesterday-content">{{yesterday.new_video_count}}</span>
                </div>
              </a-card>
            </a-col>
            <a-col :sm="4" :xs="12">
              <a-card>
                <a-statistic title="在投剧目数" :value="today.video_count" :precision="0"/>
                <a-divider/>
                <div>
                  <span class="yesterday-title">昨日</span>
                  <span class="yesterday-content">{{yesterday.video_count}}</span>
                </div>
              </a-card>
            </a-col>
            <a-col :sm="4" :xs="12">
              <a-card>
                <a-statistic title="在投基建数" :value="today.total_promotion_num" :precision="0"/>
                <a-divider/>
                <div>
                  <span class="yesterday-title">昨日</span>
                  <span class="yesterday-content">{{yesterday.total_promotion_num}}</span>
                </div>
              </a-card>
            </a-col>
            <a-col :sm="4" :xs="12">
              <a-card>
                <a-statistic title="在投有效基建数" :value="today.total_effective_promotion_num" :precision="0"/>
                <a-divider/>
                <div>
                  <span class="yesterday-title">昨日</span>
                  <span class="yesterday-content">{{yesterday.total_effective_promotion_num}}</span>
                </div>
              </a-card>
            </a-col>
            <a-col :sm="4" :xs="12">
              <a-card>
                <a-statistic title="今日有效基建数" :value="today.day_effective_promotion_num" :precision="0"/>
                <a-divider/>
                <div>
                  <span class="yesterday-title">昨日</span>
                  <span class="yesterday-content">{{yesterday.day_effective_promotion_num}}</span>
                </div>
              </a-card>
            </a-col>
            <a-col :sm="4" :xs="12">
              <a-card>
                <a-statistic title="今日新增基建数" :value="today.day_promotion_num" :precision="0"/>
                <a-divider/>
                <div>
                  <span class="yesterday-title">昨日</span>
                  <span class="yesterday-content">{{yesterday.day_promotion_num}}</span>
                </div>
              </a-card>
            </a-col>

          </a-row>
        </div>


        <div v-if="accessTo('StatController@teamStat') " class="stats-table">
          <a-month-picker v-model="teamStatQueryParam.month"  valueFormat="YYYY-MM" placeholder="请选择月份查询" :disabled="data_limit" @change="getTeamStatData"/><br><br>
          <a-table
              class="fixed"
              :columns="teamStatColumns"
              :row-key="(record,index)=>{return index}"
              :data-source="teamStatData"
              :pagination="teamStatPagination"
              size="small"
              :transform-cell-text="$helper.emptyFormat"
              @change="teamStatHandleTableChange"
          >
            <div slot="month_progress" slot-scope="month_progress" class="custom-progress">
              <span v-if="month_progress !== null">
                <a-progress  :percent="month_progress" strokeColor="#E3724E" :showInfo="false"  status="active" style="padding-right:60px;"/>
                <span style="margin-left:-60px">  {{ month_progress }}% </span>
              </span>
              <span v-else>未填写月目标</span>
            </div>
          </a-table>
        </div>


        <div v-if="accessTo('StatController@recharges')" class="stats-line">
          <div style="margin-bottom: 16px">
            <a-radio-button value="1" @click="changeDay(1)" :class="type === 1 ? 'day' : ''">
              7天
            </a-radio-button>
            <a-radio-button value="2" @click="changeDay(2)" :class="type === 2 ? 'day' : ''">
              30天
            </a-radio-button>
            <a-radio-button value="3" @click="changeDay(3)" :class="type === 3 ? 'day' : ''">
              60天
            </a-radio-button>
          </div>
          <canvas id="lineChart"></canvas>
        </div>
        <div v-if="accessTo('StatController@recharges')" class="stats-table">
          <a-table
              class="fixed"
              :columns="columns"
              :row-key="(record,index)=>{return index}"
              :data-source="data"
              :pagination="pagination"
              size="middle"
              :transform-cell-text="$helper.emptyFormat"
              @change="handleTableChange"
          >
            <div slot="total_roi" slot-scope="total_roi">
              <span :class="total_roi>=100 ? 'red' :''">{{ total_roi }}%</span>
            </div>
          </a-table>
        </div>
      </template>
    </layout>
  </div>
</template>

<style lang="less" scoped>
@import 'Home';
</style>

<script>
import Home from './Home'

export default Home
</script>
